<template>
  <div class="">
    <label
      v-if="label"
      :for="name"
      class="text-background-fg/70 mb-1 block text-left text-xs font-medium"
    >
      {{ label }}
    </label>
    <div class="flex space-x-2">
      <template v-for="rate in options" :key="rate">
        <button
          type="button"
          :disabled="disabled"
          :class="[
            inputValue === rate
              ? 'bg-primary text-primary-fg'
              : '',
            'border-background-fg/6 border-1 w-16 rounded-md px-3 py-2 font-semibold',
          ]"
          @click="setVatRate(rate)"
        >
          <template v-if="rate === null"
            ><span class="text-xs">None</span>
          </template>
          <template v-else> {{ rate }}% </template>
        </button>
      </template>
      <div class="flex items-center space-x-2">
        <input
          type="text"
          :name="name"
          :class="[
            'border-1 border-background-fg/8 block w-full max-w-24 flex-1 rounded-md text-sm font-semibold focus:outline-none sm:text-sm',
            hasError
              ? 'border-error text-error placeholder-error focus:border-error focus:ring-error'
              : 'focus:ring-primary focus:border-primary',
          ]"
          :value="inputValue"
          :aria-invalid="!!errorMessage"
          :disabled="disabled"
          enterkeyhint="done"
          @input="handleVatTextInput"
          @blur="handleBlur"
          @keydown.backspace="handleBackspace"
        />
        <span class="text-lg font-semibold">%</span>
      </div>
    </div>
    <p
      v-if="hint"
      class="text-background-fg/50 mt-1 text-xs font-medium"
    >
      {{ hint }}
    </p>
    <template v-if="errorMessage">
      <p class="text-error mt-1 text-xs font-medium">
        {{ errorMessage }}
      </p>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate"
const props = withDefaults(
  defineProps<{
    type?: string
    modelValue?: number | null
    name: string
    label: string
    placeholder?: string
    hasError?: boolean
    disabled?: boolean
    hint?: string
    options?: (number | null)[]
  }>(),
  {
    modelValue: null,
    type: "text",
    placeholder: "",
    hasError: false,
    disabled: false,
    hint: "",
    options: () => [null, 0, 5, 20],
  }
)

const {
  value: inputValue,
  errorMessage,
  handleBlur,
  handleChange,
} = useField(toRef(props, "name"), undefined, {
  ...(props.modelValue && {
    initialValue: props.modelValue,
  }),
})

const setVatRate = (value: number | null) => {
  handleChange(value)
}

const handleVatTextInput = (event: Event) => {
  const value = (event?.target as HTMLInputElement)?.value
  if (!value) handleChange(null)
  handleChange(Number(value))
}

const handleBackspace = (event: KeyboardEvent) => {
  if (inputValue.value === 0) {
    event.preventDefault()
  }
}
</script>
